<template>
  <div class="fundoPdf">
    <div style="left: 0" class="escondeZoom"></div>
    <div style="right: 0" class="escondeZoom"></div>
    <iframe :ref="arquivo" title="Arquivo" :src="linkArquivo" height="600px" width="100%"> </iframe>
  </div>
</template>
<script>
export default {
  props: {
    arquivo: {
      type: String,
      default: ''
    }
  },
  computed: {
    linkArquivo() {
      return `https://drive.google.com/file/d/${this.arquivo}/preview`
    }
  }
}
</script>
<style scoped>
.fundoPdf {
  max-width: 100%;
  height: 600px;
  width: 100%;
  background-color: #999;
}
.escondeZoom {
  position: absolute;
  width: 120px;
  height: 120px;
  background-color: transparent;
  z-index: 900;
}
.mostraDownload {
  position: absolute;
  width: 50px;
  height: 50px;
  margin: 14px;
  background-color: #999;
  z-index: 900;
}
</style>
